import { httpClient } from '../api/http.client';
import type { UploadResponse } from '@/domain/entities';

export class UploadRepository {
  async uploadImage(file: File, folder?: string): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    if (folder) {
      formData.append('folder', folder);
    }

    return httpClient.post<UploadResponse>('/api/admin/uploads/image', formData);
  }
}

export const uploadRepository = new UploadRepository();
